export class NotFoundAxiosStrategyError extends Error {
  constructor (...args) {
    super(...args);
    Error.captureStackTrace(this, NotFoundAxiosStrategyError);
  }
}
